import styled from 'styled-components';

export const StyledHelperText = styled.span`
  color: ${({ theme }) => theme.colors.fontColor};
  font-size: 12px;
  font-style: italic;
  margin: 10px 0 20px;
  display: block;
`;
